import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useMoodSelection from "../hooks/useMoodSelection";
import VideoGrid from "./VideoGrid";
import TypingHeading from "./TypingHeading";

interface FeelingSelectProps {
  selectedDate: any;
  moodImages: any;
  relevantMoods: any;
  feelingNames: any;
  imagesReady: any;
  onMoodSelected: any;
  resetKey: any;
  theme: any;
  collection: any;
}

const FeelingSelect = ({
  selectedDate,
  moodImages,
  relevantMoods,
  feelingNames,
  imagesReady,
  onMoodSelected,
  resetKey,
  theme,
  collection,
}: FeelingSelectProps) => {
  const { t } = useTranslation();

  const { selectingMood, isFadingOut, handleMoodClick, resetSelection } =
    useMoodSelection({ onMoodSelected });

  useEffect(() => {
    resetSelection();
  }, [resetKey, resetSelection]);

  const moodGenitiveLabels = useMemo(
    () =>
      moodImages.map(
        (moodImage: { moodGenitive: any }) => moodImage.moodGenitive
      ),
    [moodImages]
  );

  const onMoodClick = (index: any) => {
    handleMoodClick(
      index,
      moodGenitiveLabels,
      feelingNames,
      selectedDate,
      moodImages,
      relevantMoods
    );
  };

  return (
    <div
      style={{
        opacity: isFadingOut ? 0 : 1,
        transition: "opacity 0.3s ease-in-out",
        pointerEvents: isFadingOut ? "none" : "auto",
        backgroundColor: "#F2F2F7",
      }}
    >
      <div style={{ width: "100%", paddingTop: "16px" }}>
        <TypingHeading
          fullText={
            "How is the team?"
          } /*fullText={t("homepage.howAreYouFeeling")}*/
          skipOnInternalNavigation={false}
        />
        <VideoGrid
          moodImages={moodImages}
          relevantMoods={relevantMoods}
          videosReady={imagesReady}
          onMoodClick={onMoodClick}
          theme={theme}
          collection={collection}
        />
      </div>
    </div>
  );
};

export default FeelingSelect;
